export enum StatusHistoryConditionType {
  Actual = 'ACTUAL',
  Estimated = 'ESTIMATED',
  NotProvided = 'NOT_PROVIDED',
  NotExpected = 'NOT_EXPECTED',
}
